import type { Reactor } from './types';

/** "Sarah K." from "Sarah Khan"; single names unchanged. */
export function reactorShortName(full: string): string {
  const p = full.trim().split(/\s+/).filter(Boolean);
  return p.length > 1 ? `${p[0]} ${p[p.length - 1][0].toUpperCase()}` : p[0] ?? 'Someone';
}

/** Reactors with the viewer first (shown as "You"), otherwise oldest first. */
export function orderReactors(list: Reactor[], me: string | null | undefined): Reactor[] {
  const mine = list.filter(r => r.user_id === me);
  return [...mine, ...list.filter(r => r.user_id !== me)];
}

/** Tooltip text: "You, Sarah K and 3 others reacted with 👍". Shows up to `shown` names. */
export function reactorsSentence(list: Reactor[], emoji: string, me: string | null | undefined, shown = 2): string {
  const names = orderReactors(list, me).map(r => (r.user_id === me ? 'You' : reactorShortName(r.display_name)));
  if (!names.length) return `No one has reacted with ${emoji}`;
  const head = names.slice(0, names.length > shown + 1 ? shown : names.length);
  const rest = names.length - head.length;
  const who = rest > 0 ? `${head.join(', ')} and ${rest} other${rest > 1 ? 's' : ''}`
    : head.length === 1 ? head[0] : `${head.slice(0, -1).join(', ')} and ${head[head.length - 1]}`;
  return `${who} reacted with ${emoji}`;
}
